import { render, staticRenderFns } from "./DetailedSoldOutReport.vue?vue&type=template&id=ad7b4566&"
import script from "./DetailedSoldOutReport.vue?vue&type=script&lang=js&"
export * from "./DetailedSoldOutReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports